"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BoxVisualizerManager = void 0;
var anchor_listener_1 = require("../../canvas/listeners/anchor-listener");
var auto_scroll_listener_1 = require("../../canvas/listeners/auto-scroll-listener");
var drag_caret_listener_1 = require("../../canvas/listeners/drag-caret-listener");
var full_table_selector_listener_1 = require("../../canvas/listeners/full-table-selector-listener");
var resize_box_listener_1 = require("../../canvas/listeners/resize-box-listener");
var resize_table_listener_1 = require("../../canvas/listeners/resize-table-listener");
var anchor_visualizer_1 = require("./anchor-visualizer");
var auto_scroll_visualizer_1 = require("./auto-scroll-visualizer");
var drag_caret_visualizer_1 = require("./drag-caret-visualizer");
var full_table_selector_visualizer_1 = require("./full-table-selector-visualizer");
var resize_box_visualizer_1 = require("./resize-box-visualizer");
var resize_table_visualizer_1 = require("./resize-table-visualizer");
var BoxVisualizerManager = (function () {
    function BoxVisualizerManager(control) {
        this.dragCaretVisualizer = new drag_caret_visualizer_1.DragCaretVisualizer(control);
        this.resizeBoxVisualizer = new resize_box_visualizer_1.ResizeBoxVisualizer(control);
        this.resizeTableVisualizer = new resize_table_visualizer_1.ResizeTableVisualizer(control);
        this.anchorVisualizer = new anchor_visualizer_1.AnchorVisualizer(control);
        this.autoScrollVisualizer = new auto_scroll_visualizer_1.AutoScrollVisualizer(control);
        this.fullTableSelectorVisualizer = new full_table_selector_visualizer_1.FullTableSelectorVisualizer(control);
    }
    BoxVisualizerManager.prototype.initListeners = function (viewManager) {
        var rendererCache = viewManager.cache;
        this.dragCaretVisualizer.onChanged.add(new drag_caret_listener_1.DragCaretListener(rendererCache, viewManager.stringResources, viewManager.fieldOptions));
        this.resizeBoxVisualizer.onChanged.add(new resize_box_listener_1.ResizeBoxListener(rendererCache, viewManager.stringResources, viewManager.readOnlyPropertyHolder, viewManager.fieldOptions));
        this.resizeTableVisualizer.onChanged.add(new resize_table_listener_1.ResizeTableListener(rendererCache, viewManager.stringResources, viewManager.fieldOptions));
        this.anchorVisualizer.onChanged.add(new anchor_listener_1.AnchorListener(rendererCache, viewManager.stringResources, viewManager.readOnlyPropertyHolder, viewManager.fieldOptions));
        this.autoScrollVisualizer.onChanged.add(new auto_scroll_listener_1.AutoScrollListener(viewManager.serviceContainer));
        this.fullTableSelectorVisualizer.onChanged.add(new full_table_selector_listener_1.FullTableSelectorListener(rendererCache, viewManager.stringResources, viewManager.fieldOptions));
    };
    BoxVisualizerManager.prototype.closeDocument = function () {
        this.resizeBoxVisualizer.closeDocument();
        this.dragCaretVisualizer.closeDocument();
        this.resizeTableVisualizer.closeDocument();
        this.anchorVisualizer.closeDocument();
        this.autoScrollVisualizer.closeDocument();
        this.fullTableSelectorVisualizer.closeDocument();
    };
    return BoxVisualizerManager;
}());
exports.BoxVisualizerManager = BoxVisualizerManager;
